// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3bA8w","label":"Radio_label__uwY1K","checkMark":"Radio_checkMark__3T2AH","disabled":"Radio_disabled__2PcxF"};